// Get Url Params
// --------------------------------------------------

function urlParams(url = window.location.href) {
	const data = {};
	const query = url.split('?')[1];

	if (!query) return data;

	const params = query.split('&');

	params.forEach(function(d) {
		let pair = d.split('=');

		data[pair[0]] = pair[1];
	});

	return data;
}